/**
 * dailyCitation — Deterministic daily citation rotation
 * Each page gets a different citation (offset by pageKey).
 * Changes every day, deterministic (not random).
 */
import { RP_CITATIONS } from '../data/rpCitations';

/**
 * Simple hash of a string to a positive integer.
 */
function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

/**
 * Get the daily citation for a given page.
 * @param {string} pageKey - 'comprendre' or 'agir'
 * @param {number|string} brandId - brand identifier
 * @returns {{ text: string, author: string }}
 */
export function getDailyCitation(pageKey, brandId) {
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  const seed = hashString(`${today}_${brandId}`);
  const total = RP_CITATIONS.length;

  // Offset per page so Comprendre and Agir always show different citations
  const offset = pageKey === 'agir' ? 1 : 0;
  const index = (seed + offset) % total;

  return RP_CITATIONS[index];
}
